module.exports = __webpack_public_path__ + "assets/img/Logitech-PW-Australia-1-Landing-Page-w720.8fb387ae.jpg";